import React from "react";
import { createGlobalStyle } from "styled-components";

import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

const CustomModal = ({ open, handleClose, children, title, header }) => {
  return (
    <>
      <GlobalStyle />
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-title"
        slotProps={{
          backdrop: {
            style: {
              backgroundColor: " rgba(0, 0, 0, 0.5)",
              backdropFilter: "blur(2px)",
            },
          },
        }}
      >
        <div className={`modal-container ${!title ? "no-title" : ""}`}>
          <div className="modal-header">
            {title && (
              <Typography id="modal-title" component="h5">
                {title}
              </Typography>
            )}
            {!title && header}
            <IconButton
              className={`close-btn ${!title ? "abs-pos" : ""}`}
              aria-label="Close"
              onClick={handleClose}
            >
              <CloseIcon />
            </IconButton>
          </div>
          <div className={!title ? "modal-content--no-title" : "modal-content"}>
            {children}
          </div>
        </div>
      </Modal>
    </>
  );
};

const GlobalStyle = createGlobalStyle`
.modal-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  min-width: 400px;
  min-height: 50px;
  background-color: var(--white);
  padding: 30px;
  border-radius: 6px;

  &:focus-visible, &:focus {
    border: none;
  }

  &.no-title {
    padding: 15px;
  }
}

.modal-header {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;

  #modal-title {
    font-size: 24px;
    font-weight: 700;
  }
  
  button.close-btn {
    background-color: var(--menu-link-color);
    width: 20px;
    height: 20px;

    svg {
      width: 15px;
      color: var(--white)
    }

    &.abs-pos {
      position: absolute;
      right: 0;
      top: 0;
    }
  }  
}

.modal-content {
  margin-top: 15px;
}

.modal-content--no-title {
  padding: 0 35px 0 0;
  margin: 0;
}
`;

export default CustomModal;
